<template>
    <div class="videos-grid">
        <div class="video-wrapper">
            <video controls="true" muted>
                <source src="../assets/appmovie.mp4" type="video/mp4">
            </video>
            <p>Full App Walktrough</p>
        </div>
        <div class="video-wrapper">
            <video controls="true" muted>
                <source src="../assets/IntroductionExplore.mp4" type="video/mp4">
            </video>
            <p>Introduction Explore - Tab</p>
        </div>
         <div class="video-wrapper">
            <video controls="true" muted>
                <source src="../assets/LocationAndOfflineMode.mp4" type="video/mp4">
            </video>
            <p>Change Location And Offline Mode</p>
        </div>       
         <div class="video-wrapper">
            <video controls="true" muted>
                <source src="../assets/Invoices.mp4" type="video/mp4">
            </video>
            <p>Scan Invoices</p>
        </div>             
    </div>
</template>


<script>
export default {
  name: "Videos",
  props: []
};
</script>

<style lang="scss" scoped>
.videos-grid{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.video-wrapper{
    margin: 2.5%;
    padding: 1%;
    border-radius: 5px;
-webkit-box-shadow: 15px 11px 19px -24px rgba(0,0,0,0.75);
-moz-box-shadow: 15px 11px 19px -24px rgba(0,0,0,0.75);
box-shadow: 15px 11px 19px -24px rgba(0,0,0,0.75);
    p{
        text-align: center;
        font-size: 1.2rem;
        padding: 5%;
    }
}

video{
    flex: 1;
    min-width: 350px;
    height: 350px;
    background-color: black;
}
</style>
